import React from "react";
import AssetDetail from "../components/AssetDetail";

const AssetDetailPage = () => {
  return <AssetDetail />;
};

export default AssetDetailPage;
